import { ClaimsSection } from "@/features/patient/insurance/components/ClaimsView";
import { sampleClaims, sampleInsuranceProviders } from "@/data/patient/health.mock";

export function ClaimsPage() {
  return <ClaimsSection claims={sampleClaims} providers={sampleInsuranceProviders} />;
}
